import type { ReactNode } from 'react'
import { Link } from '@tanstack/react-router'
import { ChevronRight } from 'lucide-react'
import { Fragment } from 'react'

interface BreadcrumbItem {
  label: string
  path?: string
}

interface PageHeaderProps {
  title: string
  subtitle?: string
  breadcrumbs?: BreadcrumbItem[]
  actions?: ReactNode
}

export function PageHeader({ title, subtitle, breadcrumbs, actions }: PageHeaderProps) {
  return (
    <div className="pb-4 mb-6 border-b border-zinc-100">
      {breadcrumbs && breadcrumbs.length > 0 && (
        <nav className="flex items-center gap-1 text-xs text-zinc-400 mb-2">
          {breadcrumbs.map((crumb, i) => (
            <Fragment key={`${crumb.path ?? 'current'}-${crumb.label}`}>
              {i > 0 && <ChevronRight size={12} className="shrink-0" />}
              {crumb.path ? (
                <Link to={crumb.path} className="hover:text-zinc-600 transition-colors">
                  {crumb.label}
                </Link>
              ) : (
                <span className="text-zinc-600">{crumb.label}</span>
              )}
            </Fragment>
          ))}
        </nav>
      )}
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-xl font-semibold text-zinc-900">{title}</h1>
          {subtitle ? <p className="text-sm text-zinc-500 mt-0.5">{subtitle}</p> : null}
        </div>
        {actions ? <div className="shrink-0">{actions}</div> : null}
      </div>
    </div>
  )
}
